export enum RuleId {
  calcMaxContiguousSpace = 5,
  multiCalcMaxContiguousSpace = 13,
  rateIsNotNet = 3,
  DisableAvailabilitytypeLease = 6,
  DisableAvailabilitytypeSale = 7,
  nonCBREDeal = 1,
}
